// hooks/useRememberedCredentials.tsx
import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { FontAwesome } from "@expo/vector-icons";

interface RememberLoginProps {
  rememberMe: boolean;
  setRememberMe: (value: boolean) => void;
  style?: object;
}

function RememberLogin({
  rememberMe,
  setRememberMe,
  style,
}: RememberLoginProps): React.JSX.Element {
  return (
    <View style={[styles.container, style]}>
      <TouchableOpacity
        style={styles.checkbox}
        testID="remember-me-checkbox"
        onPress={() => setRememberMe(!rememberMe)}
        accessibilityRole="checkbox"
        accessibilityState={{ checked: rememberMe }}
      >
        {rememberMe && (
          <FontAwesome
            testID="remember-me-checked-icon"
            name="check"
            size={18}
            color="#4299E1"
          />
        )}
      </TouchableOpacity>
      <Text style={styles.text}>Remember me</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 10,
  },
  checkbox: {
    width: 20,
    height: 20,
    borderWidth: 1,
    borderColor: "#2D3748",
    borderRadius: 4,
    marginRight: 6,
    justifyContent: "center",
    alignItems: "center",
  },
  text: {
    fontSize: 16,
    color: "#2D3748",
  },
});

export default RememberLogin;
